import React from 'react';

import { DEFAULT_MARKET } from 'utils/market/market';
import { DEFAULT_LOCALE } from 'utils/i18n/localeConfig';
import { MarketConfig } from 'data/market/types';

interface MarketContextProps {
  market: MarketConfig;
  children: React.ReactNode;
}

export const MarketContext = React.createContext<MarketConfig>({
  marketCode: DEFAULT_MARKET,
  locale: DEFAULT_LOCALE,
  dir: 'ltr',
  preferredDir: 'ltr',
  displayNameWithLanguage: 'USA',
});

const MarketProvider = ({ market, children }: MarketContextProps) => {
  return <MarketContext.Provider value={market}>{children}</MarketContext.Provider>;
};

export default MarketProvider;
